import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./action";
import axios from "axios";
import { axiosPrivate } from "../../Helpers/axios";

const AUTH_DASHBOARD_URL = process.env.REACT_APP_AUTH_SERVER_PRODUCTION || "https://uat-cou-authdash-idfc.plutos.one/v1"
function* addAgentResponse({ payload: { data } }) {
  try
  {
    const token = sessionStorage.getItem("biller_access");
    if (!token) throw new Error("No authentication token found");

    const response = yield call(
      axios.post,
      `${AUTH_DASHBOARD_URL}/organizations/create`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  

    if (response.status === 201) {
      yield put(actions.addAgentSuccess(response.data.message));
      yield put(actions.getAgentsData());
    } else {
      throw new Error(response.data?.message || "Failed to add organization");
    }
  } catch (error) {
    console.error("Error in addAgent saga:", error);
    // Use the error message from the response if available
    const errorMsg =
      error.response?.data?.message || error.message || "Network error";
    yield put(actions.addAgentFailed(errorMsg));

    // if (error.response?.status === 401 && errorMsg.includes("Token")) {
    //   sessionStorage.removeItem("biller_access");
    //   localStorage.removeItem("module_access");
    //   window.location.href = "/login";
    // }
  }
}

function* getAgentsDataResponse() {
  
  try {
    const token = sessionStorage.getItem("biller_access");

    if (!token) {
      throw new Error("No authentication token found");
    }

    const response = yield call(
      axios.get,
      `${AUTH_DASHBOARD_URL}/organizations/getall`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200) {
      // Pass the entire data array to the success action
      yield put(actions.getAgentsDataSuccess(response.data.data));
    } else {
      throw new Error(response.data.message || "Failed to fetch agents");
    }
  } catch (error) {
    console.error("Error fetching agents:", error);
    yield put(actions.getAgentsDataFailed(error.message));

    // Handle token expiration
    if (error.response?.status === 401) {
      sessionStorage.removeItem("biller_access");
      localStorage.removeItem("module_access");
      window.location.href = "/login";
    }
  }
}

function* updateAgentResponse({ payload: { orgId, payload } }) {
  try {
    const token = sessionStorage.getItem("biller_access");
    if (!token) throw new Error("No authentication token found");

    // Format scopes as space-separated string if it's an array
    if (Array.isArray(payload.scopes)) {
      payload.scopes = payload.scopes.join(" ");
    }

    const response = yield call(
      axios.put,
      `${AUTH_DASHBOARD_URL}/organizations/cou/update/${payload.orgId}`,
      payload ,
       {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
      
    );

    if (response.status === 200) {
      yield put(
        actions.updateAgentSuccess(orgId, response.data.message, payload)
      );
      // Optionally refresh the list
      yield put(actions.getAgentsData());
    } else {
      throw new Error(
        response.data?.message || "Failed to update organization"
      );
    }
  } catch (error) {
    console.error("Error in updateAgent saga:", error);
    const errorMsg =
      error.response?.data?.message || error.message || "Network error";
    yield put(actions.updateAgentFailed(errorMsg));

  }
}

export default function* rootSaga()
{
  yield all( [ takeEvery( actions.ADD_AGENT, addAgentResponse ) ] );
  yield all( [ takeEvery( actions.GET_AGENTS_DATA, getAgentsDataResponse ) ] );
  yield all( [ takeEvery( actions.UPDATE_AGENT, updateAgentResponse ) ] );

}